import React, { Component } from 'react'
import imgResize from '@/utils/img-resize'
import styles from './index.module.less'

interface Iprops {
  propsConfig: {
    top: string
    bottom: string
    left: string
    right: string
    iconSrc: string
  }
}

const getHeight = () => (typeof window === 'undefined' ? document.body.clientHeight : 0)

class BackTop extends Component<Iprops, any> {
  static config = {
    name: 'poizon-back-top',
  }

  state = {
    visible: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler)
  }

  scrollHandler = () => {
    const htmls = document.getElementsByTagName('html')
    if (htmls.length) {
      const scrollTop = htmls[0].scrollTop
      if (scrollTop > getHeight()) {
        if (!this.state.visible) {
          this.setState({
            visible: true,
          })
        }
      } else if (this.state.visible) {
        this.setState({
          visible: false,
        })
      }
    }
  }

  backToTop = () => {
    if (typeof window !== 'undefined') {
      const htmls = document.getElementsByTagName('html')
      if (htmls.length) {
        htmls[0].scrollTop = 0
      }
    }
  }

  render() {
    const { propsConfig } = this.props
    const { visible } = this.state
    const { iconSrc, top, bottom, left, right } = propsConfig || {}
    if (!visible) {
      return null
    }
    return (
      <img
        style={{
          top,
          bottom,
          left,
          right,
        }}
        onClick={this.backToTop}
        className={styles['back-top-wrapper']}
        data-layzload-src={imgResize(iconSrc, 80)}
        alt=""
      />
    )
  }
}

BackTop.config = {
  name: 'poizon-back-top',
}

export default BackTop
